import { Skeleton } from '@/components/ui';

export function CategoryTabsSkeleton({ className }: { className?: string }) {
  return (
    <div className={`w-full ${className ?? ''}`}>
      <div className="flex items-center bg-surface h-[58px] overflow-hidden gap-3 px-3">
        <Skeleton className="size-[38px] rounded-lg flex-shrink-0" />
        {[80, 64, 56, 60, 96].map((w, i) => (
          <Skeleton key={i} className="h-9 rounded-tab flex-shrink-0" style={{ width: w }} />
        ))}
      </div>
    </div>
  );
}
